<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <b-tabs content-class="mt-3">
              <b-tab title="Details" active>
                <form-group label="Insurance Jobs">
                  <b-form-checkbox
                    v-model="partner.is_insurance_jobs"
                    value="1"
                    unchecked-value="0"
                  >
                    Insurance Job / Requires client details
                  </b-form-checkbox>
                </form-group>

                <form-group label="Shipping">
                  <b-form-checkbox
                    v-model="partner.is_shipping_required"
                    value="1"
                    unchecked-value="0"
                  >
                    Jobs Require Shipping
                  </b-form-checkbox>
                </form-group>

                <form-group label="Code" :required="true">
                  <input
                    type="text"
                    @blur="$v.partner.code.$touch"
                    class="form-control"
                    :class="{ 'is-invalid': $v.partner.code.$error }"
                    v-model="partner.code"
                    v-uppercase
                  />
                  <div class="invalid-feedback" v-if="!$v.partner.required">
                    Please enter code
                  </div>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.partner.code.maxLength"
                  >
                    Only 10 characters allowed
                  </div>
                </form-group>

                <form-group label="Name" :required="true">
                  <input
                    type="text"
                    @blur="$v.partner.name.$touch"
                    class="form-control"
                    :class="{ 'is-invalid': $v.partner.name.$error }"
                    v-model="partner.name"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="!$v.partner.name.required"
                  >
                    Please enter name
                  </div>
                </form-group>

                <form-group label="Partner Type" :required="true">
                  <b-form-select
                    @blur="$v.partner.partner_type.$touch"
                    :class="{ 'is-invalid': $v.partner.partner_type.$error }"
                    v-model="partner.partner_type"
                  >
                    <b-form-select-option
                      v-for="pt in partnerTypes"
                      :value="pt"
                      :key="pt"
                      >{{ pt }}</b-form-select-option
                    >
                  </b-form-select>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.partner.partner_type.required"
                  >
                    Please select partner type
                  </div>
                </form-group>

                <form-group label="Contact Number" :required="true">
                  <input
                    type="text"
                    class="form-control"
                    v-model="partner.contact_number"
                    @blur="$v.partner.contact_number.$touch"
                    :class="{ 'is-invalid': $v.partner.contact_number.$error }"
                  />
                </form-group>

                <form-group label="Contact Number 2">
                  <input
                    type="text"
                    class="form-control"
                    v-model="partner.contact_number_2"
                  />
                </form-group>

                <form-group label="Email">
                  <input
                    type="email"
                    class="form-control"
                    v-model="partner.email_address"
                  />
                </form-group>

                <form-group label="Email Jobs">
                  <input
                    type="email"
                    class="form-control"
                    v-model="partner.email_address_jobs"
                  />
                </form-group>

                <form-group label="Email Accounts">
                  <input
                    type="email"
                    class="form-control"
                    v-model="partner.email_address_accounts"
                  />
                </form-group>

                <form-group label="Address">
                  <textarea-autosize class="form-control" v-model="partner.address" />
                </form-group>

                <form-group label="City">
                  <input
                    type="text"
                    class="form-control"
                    v-model="partner.city"
                  />
                </form-group>

                <form-group label="Postal Code">
                  <input
                    type="text"
                    class="form-control"
                    v-model="partner.postal_code"
                  />
                </form-group>

                <form-group label="Province">
                  <b-form-select v-model="partner.province_id">
                    <b-form-select-option
                      v-for="pr in provinces"
                      :value="pr.id"
                      :key="pr.id"
                      >{{ pr.province }}</b-form-select-option
                    >
                  </b-form-select>
                </form-group>

                <form-group label="VAT Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="partner.vat_number"
                  />
                </form-group>

                <form-group label="Reg Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="partner.registration_number"
                  />
                </form-group>

                <form-group label="FSP Number">
                  <input
                    type="text"
                    class="form-control"
                    v-model="partner.fsp_number"
                  />
                </form-group>

                <div class="scroller300" v-if="partner.is_insurance_jobs == 1">
                  <form-group :required="true" label="Schemes">
                    <table class="table table-sm">
                      <tr v-for="item in schemes" :key="item.id">
                        <td class="border-0">
                          <b-form-checkbox
                            v-model="partner.schemes"
                            :value="item.id"
                          >
                            <span class="text-body">{{ item.name }}</span>
                          </b-form-checkbox>
                        </td>
                      </tr>
                    </table>

                    <div class="text-danger" v-if="$v.partner.schemes.$error">
                      Please select schemes
                    </div>
                  </form-group>
                </div>
              </b-tab>
              <b-tab title="Markups">
                <form-group label="Optional Custom Parts Markup%">
                  <input
                    type="number"
                    min="0"
                    max="1000"
                    class="form-control"
                    v-model="partner.parameters.parts_markup"
                  />
                </form-group>

                <form-group label="Quotation Rejection Fee">
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model="partner.parameters.quotation_rejection_fee"
                  />
                </form-group>

                <form-group label="Labour Fee">
                  <input
                    type="number"
                    min="0"
                    max="1000"
                    class="form-control"
                    v-model="partner.parameters.labour_fee"
                  />
                </form-group>

                <form-group label="BER Fee">
                  <input
                    type="number"
                    min="0"
                    max="1000"
                    class="form-control"
                    v-model="partner.parameters.ber_fee"
                  />
                </form-group>

                <form-group label="Courier Fee">
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model="partner.parameters.courier_fee"
                  />
                </form-group>
              </b-tab>
            </b-tabs>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import partnerRepo from "@/api/repos/partnerRepo";
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    partner: {
      code: {
        required,
        maxLength: maxLength(10),
      },
      name: {
        required,
      },
      partner_type: {
        required,
      },
      contact_number: {
        required,
      },
      schemes: {
        required: requiredIf(function (partner) {
          return partner.is_insurance_jobs == 1;
        }),
      },
    },
  },

  mounted() {
    this.getCreatedData();
  },

  data() {
    return {
      provinces: [],
      partner: {
        schemes: [],
        parameters: {},
        is_insurance_jobs: 0,
        is_shipping_required: 0,
      },
      partnerTypes: {},
      schemes: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
    };
  },

  methods: {
    async getCreatedData() {
      try {
        this.loading = true;
        let { data } = await partnerRepo.createRelatedData();
        this.partnerTypes = data.partner_types;
        this.schemes = data.schemes;
        this.provinces = data.provinces;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await partnerRepo.create(this.partner);
          this.$emit("partnerCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

<style></style>
